import React, { useEffect, useRef, useState } from 'react';
import data from '../../database/data';
import style from './homepage.module.css';
import aboutImage from'../../assets/check.png';
import Whyus from '../../components/whyUs/Whyus';
import SolidBtns from '../../components/buttons/SolidBtns';
import OutlineBtns from '../../components/buttons/OutlineBtns';
import Footer1 from '../../components/footer1/Footer1';
import Homeproject from '../../components/homeProject/Homeproject';
import { HiArrowSmLeft, HiArrowSmRight } from 'react-icons/hi';
import Readytotake from '../../components/readyToTake/Readytotake';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import the AOS CSS file for styling
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'

const Home = () => {


// __________________________________________________________________

const formRef = useRef(null)
  
  
const scriptUrl = "https://script.google.com/macros/s/AKfycbzmG5HR_-qB0lV2pdiXXNrzgjjFL-9yId1ZPACpsrqnhgxrfPwCYfp4d7wJ_Lq7k18q4g/exec"

  const [loading, setLoading] = useState(false)

  const handleSubmit = (e) =>{
      e.preventDefault()
      setLoading(true)

      fetch(scriptUrl, {
      method: 'POST', 
      body: new FormData(formRef.current),

  }).then(res => {
          console.log("SUCCESSFULLY SUBMITTED")
          setLoading(false)
          toast({
            title: 'Succesfully Registered',
            description: "We'll get back to you soon.",
            status: 'success',
            duration: 3000,
            isClosable: true,
          })
      })
      .catch(err => console.log(err))
  }

// ___________________________________________________________________



  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast()

  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const testimonials= data.testimonials;
  // console.log(testimonials);

  const goToNextTestimonial = () => {
    setCurrentTestimonial((prevIndex) => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
  };

  const goToPreviousTestimonial = () => {
    setCurrentTestimonial((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
  };

  useEffect(() => {
    AOS.init();
    // Auto-rotate testimonials every 5 seconds
    const interval = setInterval(goToNextTestimonial, 5000);
    return () => clearInterval(interval);  
  }, []);

  return (
    <div className={style.homeMain}>
   
      {/* Hero Section */}
      <div className={style.heroSection}>
        <div className={style.heroSectionContainer}>
          <div className={style.heroTextBox}>
              <p>Transforming businesses with cutting-edge blockchain solutions</p>
              <h1 className={style.typinganimation}>Revolutionize Your Industry with Blockchain Technology Explore the Possibilities</h1>
              <div className={style.heroBtns}>
                  <SolidBtns
                  link="/projects"
                  text="Our Previous Projects"
                  />
                  <OutlineBtns
                  link='/about'
                  text='More About Us'
                  />
              </div>
          </div>
        </div>
      </div>

      


      {/* About Section */}
      <div className={style.aboutSection}>
        <div className={style.aboutSectionContainer}>
            <div className={style.aboutTextBox}>
              <h2>About</h2>
              <div>
              <h1><span className={style.bold1}>We believe that</span> <span className={style.italic1}>technology</span></h1>
              <h1 className={style.bold2}>can transform the world.</h1>
              </div>
              <p><span className={style.paraBold1}>Your Gateway to Blockchain, Cloud, AI, and IoT:</span> AradChain Technologies driving digital transformation</p>
              <p>Transform your bold ideas into reality with AradChain, a leading blockchain development company. Our tailored outsourcing services encompass NFT Marketplace, Blockchain Development, Multi Level Marketing, Crowd Funding, Crypto Websites, and Other Cutting-Edge Blockchain Products.</p>
            </div>
            <div className={style.aboutImage}>
              <img src={aboutImage} alt="image" />
            </div>

        </div>
      </div>



      {/* Why Us Section */}
      <div className={style.whySection}>
        <div className={style.whySectionContainer}>
          <div className={style.whyContent}>
            <h1>Why Us?</h1>
            <div className={style.whyBoxes}>
                {
                  data.whyUs.map((ele)=>{
                    return (
                      <Whyus
                      key={ele.id}
                      image={ele.image}
                      title={ele.title}
                      desc={ele.desc}
                      alt={ele.title}
                      />
                    )
                  })
                }
            </div>
          </div>
        </div>
      </div>



      {/* Services Section */}
      <div className={style.servicesSection}>
        <div className={style.servicesContainer}>
          <div className={style.servicesLeft}>
            <div>
              <Link to="/services/nft-marketplace" onClick={() => {window.scroll(0, 0);}}><h2>NFT Marketplace</h2></Link>
              <Link to="/services/blockchain-development" onClick={() => {window.scroll(0, 0);}}><h2>Blockchain Development</h2></Link>
              <Link to="/services/blockchain-mlm" onClick={() => {window.scroll(0, 0);}}><h2>Blockchain Based MLM</h2></Link>
            </div>
          </div>
          <div className={style.servicesMid}>
            <div>
              <Link to="/services/crypto-funding" onClick={() => {window.scroll(0, 0);}}><h2>Crypto Funding</h2></Link>
              <Link to="/services/crypto-websites" onClick={() => {window.scroll(0, 0);}}><h2>Crypto Websites</h2></Link>
            </div>
          </div>
          <div className={style.servicesRight}>
            <h1>Services</h1>
            <p>We provide customized solutions that meet our clients' unique needs and help them succeed in an increasingly digital world.</p>
            <OutlineBtns
            link="/services"
            text="Explore Our Services"
            />
          </div>
        </div>
      </div>


      
      {/* Project Section */}
      <div className={style.projectsSection}>
        <div className={style.projectsContainer}>
          <div className={style.projectHeading}>
            <h1>Project</h1>
            <OutlineBtns
            text="More Projects"
            link="/projects"/>
          </div>
          <div className={style.projectContent}>
            {
              data.projects.slice(0,3).map((ele)=>{
                return(
                  <Homeproject
                  slug={ele.slug}
                  key={ele.id}
                  index={ele.id}
                  client={ele.client}
                  year={ele.year}
                  image={ele.image}
                  shortDesc={ele.shortDesc}
                  />
                )
              })
            }
          </div>
        </div>
      </div>

      {/* Ready to take */}
      <div className={style.readyToTake}>
        <Readytotake/>
      </div>

      {/* Testimonial Section */}
      <div className={style.testimonialSection}>
        <div className={style.testimonialContainer}>
          <div className={style.testimonialLeft}>
              <HiArrowSmLeft onClick={goToPreviousTestimonial}/>
          </div>
          <div className={style.testimonialMid}>
            <h2>{testimonials[currentTestimonial].testimonial}</h2>
            <img src={testimonials[currentTestimonial].image} alt="" />
            <p>{testimonials[currentTestimonial].name}</p> 
            <p>{testimonials[currentTestimonial].country}</p>
          </div>
          <div className={style.testimonialRight}>
          <HiArrowSmRight onClick={goToNextTestimonial}/>
          </div>
        </div>
      </div>



      {/* Affiliate Section */}

      <div className={style.affiliateSection}>
        <div className={style.affiliateContainer}>
          <div>
            <h1>Are you a consultant or technology company?</h1>
            <p>Become an affiliate and start earning today..</p>
          </div>
          <SolidBtns
          text="Register Now"
          onClick={onOpen}
          />
        </div>
      </div>



      {/* Affiliate Form Popup- Chakra UI Component */}

      <Modal
        isCentered
        onClose={onClose}
        isOpen={isOpen}
        motionPreset='slideInBottom'
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Become an affiliate</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form ref={formRef} onSubmit={handleSubmit} name="google-sheet">
              <input required type="text" placeholder='Enter your name' name="Name"/>
              <input required type="email" placeholder='Enter your email' name="Email" />
              <input type="submit" placeholder='Register' value={loading ? "Registering..." : "REGISTER"} name="submit"/>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>



      {/* Blog Section*/}

      <div className={style.blogSection}>
        <div className={style.blogContainer}>
          <h1>Blog</h1>
          <div className={style.blogContent}>
            <OutlineBtns text="READ MORE ARTICLES" link="/blogs"/>
            {
              data.blogPosts.slice(0,2).map((ele)=>{
                return(

                  <Link to={ele.slug} onClick={() => {window.scroll(0, 0);}}>
                <div>
                  <img src={ele.image} alt="" />
                  <h2>{ele.title}</h2>
                  <p>{ele.date}</p>
                </div>
              </Link>

                )
                
              })
            }
            {/* <Link to="article/blockchain-technology" onClick={() => {window.scroll(0, 0);}}>
              <div>
                <p>TECH</p>
                <h2>Blockchain Technology: Revolutionizing the Future</h2>
                <h3>30.06</h3>
              </div>
            </Link>
            
            <Link to="/article/nft-marketplaces" onClick={() => {window.scroll(0, 0);}}>
              <div>
                <p>TECH</p>
                <h2>NFT Marketplaces: Transforming the World of Digital Assets</h2>
                <h3>25.04</h3>
              </div>
            </Link> */}
          </div>
        </div>
      </div>


      
{/* Footer Section */}
      <div className={style.footerSection}>
        <Footer1/> 
      </div>
      
    </div>
  )
}

export default Home
